var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 30H5V6.25C5 5.55937 4.44063 5 3.75 5H1.25C0.559375 5 0 5.55937 0 6.25V32.5C0 33.8805 1.11953 35 2.5 35H38.75C39.4406 35 40 34.4406 40 33.75V31.25C40 30.5594 39.4406 30 38.75 30ZM36.25 7.5H27.0266C25.3563 7.5 24.5195 9.51953 25.7008 10.7008L28.232 13.232L22.5 18.9648L16.768 13.2328C15.7914 12.2563 14.2086 12.2563 13.2328 13.2328L7.86641 18.5992C7.37813 19.0875 7.37813 19.8789 7.86641 20.3672L9.63359 22.1344C10.1219 22.6227 10.9133 22.6227 11.4016 22.1344L15 18.5352L20.732 24.2672C21.7086 25.2437 23.2914 25.2437 24.2672 24.2672L31.7672 16.7672L34.2984 19.2984C35.4797 20.4797 37.4992 19.643 37.4992 17.9727V8.75C37.5 8.05938 36.9406 7.5 36.25 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.354294a903d424de0d9fefef247af161.svg";
export { ForwardRef as ReactComponent };